export default __webpack_public_path__ + "static/media/alert_square_icon.f3db417e.svg";